import React from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import { PrivacyPoliciesTerms } from "variables/privacyPoliciesTerms";
import UtilsFncs from "utils/UtilsFncs";
import storageFnc from "lib/localStorage.js";
import hexToRgb from "assets/theme/hex-to-rgb";

const useStyles = makeStyles({
  formControlRoot: {
    "& > span": {
      fontSize: "1rem",
    },
  },
});

const useStylesScroll = makeStyles((theme) => ({
  scrollbarClass: {
    overflowY: "auto",
    marginRight: 10,
    padding: 0,
    "&::-webkit-scrollbar": {
      width: "0.45rem",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "1.5rem",
      borderRadius: 4,
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.2)`,
      outline: `rgba(${hexToRgb(theme.palette.black.main)}, 0.7)`,
    },
  },
}));

export default function DialogPrivacyPolicies({ open, handleClose, onAccept }) {
  const classes = useStyles();
  const classScrollbar = useStylesScroll();
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);
  const snackbar = useSnackbar();
  const [confirmando, setConfirmando] = React.useState(false);
  const [userIp, setUserIp] = React.useState(null);

  const handleTermsChange = React.useCallback((event) => {
    setAcceptedTerms(event.target.checked);
  }, []);

  const handleCancel = React.useCallback(() => {
    storageFnc.clear();
    handleClose();
  }, [handleClose]);

  const submit = React.useCallback(async () => {
    setConfirmando(true);

    await Api.put(
      "user-acceptance-term",
      "adminportal",
      {
        termoAceito: "true",
        termoUsoIp: userIp,
      },
      true
    )
      .then((res) => {
        if (res.Success) {
          onAccept();
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(
          "Ocorreu um erro ao aceitar os termos de uso e de políticas de privacidade.",
          {
            severity: "error",
          }
        );
        setConfirmando(false);
      });
  }, [onAccept, snackbar, userIp]);

  React.useEffect(() => {
    UtilsFncs.GetIp((ip) => {
      if (ip) {
        setUserIp(ip);
      }
    });
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Termos de Políticas de Privacidade do App e Portal Karsten
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classScrollbar.scrollbarClass,
        }}
        style={{
          padding: "0 1.5rem",
          marginTop: "0.5rem",
        }}
      >
        <DialogContentText id="scroll-dialog-description" tabIndex={-1} color="textPrimary">
          <PrivacyPoliciesTerms />
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                checked={acceptedTerms}
                onChange={handleTermsChange}
                color="primary"
              />
            }
            label="Li e aceito os termos de políticas de privacidade acima."
            labelPlacement="end"
            classes={{
              root: classes.formControlRoot,
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={handleCancel} disabled={confirmando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={submit}
          disabled={confirmando || !acceptedTerms}
        >
          {confirmando ? "Salvando Aceite..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
